import React from 'react';
import './style.css';

export default function Loader() {
    return (
      <div className="section-loader">
         <div className="loader-spin"></div>
      </div>
    );
}